import React, { useCallback, useEffect, useState } from 'react'
import { MainRouteSubRoutePage } from '../../AppControl/RoutePage'
import { useMergeState } from '../../../irmlib/src/hooks'
import { getUser } from '../../../redux/global'
import { setBusy, clearBusy } from 'irmlib/containers'
import { useTranslation } from 'react-i18next'
import * as localGdeTransactions from '../../../services/firestore/localGdeTransactions'
import { FormControl, makeStyles, TextField } from '@material-ui/core'
import { OutlinedButton } from '../../../irmlib/src/components/Controls'
import ViewQualityCheckImagesData from './ViewQualityCheckImagesData'
import MuiAutocomplete from '@material-ui/lab/Autocomplete'
import { errorToast } from '../../../common/functions'


const useStyles = makeStyles((theme) => ({
  formButtonContainer: {
    display: 'flex',
    justifyContent: 'center'
  },
  topControlContainer: {
    display: 'flex',
    columnGap: '1em',
    marginBottom: '1em'
  }
}))

const initialSate = {
  districtsList: [],
  buildindList: [],
  selectedDistrict: '',
  selectedBuilding: ''
}

const ViewQualityCheckImages = (props) => {
  const { t } = useTranslation()
  const userval = getUser()
  const { country, district } = userval
  const [searchBtnDisabled, setSearchBtnDisabled] = useState(true)
  const { selectedBuilding, selectedDistrict } = JSON.parse(localStorage.getItem('localAlQcImgListFilters') || '{}')
  // const persistDistrict = districtFromStorage?.length ? districtFromStorage : [userval?.district]
  const [val, Setval] = useState({ localQcDistrict: selectedDistrict || district, localQcBuilding: selectedBuilding || '' })
  const classes = useStyles()
  const [state, setState, getState] = useMergeState(initialSate)
  
  useEffect(() => {
    handleDistrictOnChange(null, selectedDistrict || district, null, true, selectedBuilding || '')
    // setState({ loggedInDistrict: district, country: country, selectedDistrict: district })
    getDistricts(country)
  }, [])

  const getDistricts = async (country = '') => {
    setBusy()
    let collection
    if (country) {
      collection = await localGdeTransactions.getDistrictsByCountry(country)
    } else {
      collection = await localGdeTransactions.getDistricts()
    }
    const districtsList = []
    collection?.forEach((doc) => {
      // districtsList.push({ value: doc.data().districtName, label: doc.data().districtName })
      districtsList.push(doc.data().districtName)
    })
    setState({ districtsList: districtsList })
    clearBusy()
  }

  const handleCLick = () => {
    if (state.selectedDistrict && state.selectedDistrict !== '') {
      Setval({ localQcDistrict: state.selectedDistrict, localQcBuilding: state.selectedBuilding })
      // saving data to local storage
      const qcListViewData = {
        selectedDistrict: state.selectedDistrict,
        selectedBuilding: state.selectedBuilding
      }
      localStorage.setItem('localAlQcImgListFilters', JSON.stringify(qcListViewData))
    } else {
      errorToast({ message: t('toast.invalidDistrict'), title: t('toast.error'), autoHideDuration: 3000, isBlocking: false })
    }
  }

  const handleDistrictOnChange = async (e, newValue, reason, initialRender, buildingValueforIntialRendner) => {
    if (newValue) {
      try {
        // fetech all the building with that district
        setBusy()
        setState({ selectedBuilding: '' })
        const buildingsData = await localGdeTransactions.getBuildingForDistrict(newValue)
        setState({ selectedDistrict: newValue })
        setState({ buildindList: Object.values(buildingsData || {}) })
        if (initialRender && buildingValueforIntialRendner && Object.values(buildingsData || {}).includes(buildingValueforIntialRendner)) {
          setState({ selectedBuilding: buildingValueforIntialRendner })
        } else {
          setSearchBtnDisabled(false)
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log('error while feteching buildings-', err)
      } finally {
        clearBusy()
      }
    } else {
      setState({ selectedBuilding: '', selectedDistrict: '', buildindList: [] })
      setSearchBtnDisabled(true)
    }
  }

  const handlleBuildingChange = (e, newValue) => {
    // disable the search buttton no distrcit selected
    if (!state.selectedDistrict || state.selectedDistrict?.trim() === '') {
      setSearchBtnDisabled(true)
    } else {
      setSearchBtnDisabled(false)
    }
    setState({ selectedBuilding: newValue })
  }

  const handleSearchDisabled = useCallback((val) => setSearchBtnDisabled(val), [])
  return (
    <>

      <MainRouteSubRoutePage
        mainTitle='routeTitles.localQC'
      >
        {/* container for the search bar control */}
        <div className={classes.topControlContainer}>
          <MuiAutocomplete
            value={state.selectedDistrict}
            id='imageQc-district-autocomplete'
            options={state.districtsList}
            defaultValue={district}
            getOptionLabel={(option) => option}
            onChange={handleDistrictOnChange}
            renderInput={(params) => <TextField {...params} style={{ width: '200px' }} error={state.selectedDistrict === '' || !state.selectedDistrict} label={t('templates.district')} variant="outlined" />}
          />
          <MuiAutocomplete
            value={state.selectedBuilding}
            id='imageQc-district-autocomplete'
            options={state.buildindList}
            getOptionLabel={(option) => option}
            onChange={handlleBuildingChange}
            disabled={state.buildindList.length < 1}
            // inputValue={finalDist[0]}
            renderInput={(params) => <TextField {...params} style={{ width: '200px' }} label={t('templates.buildings')} variant="outlined" />}
          />
          <FormControl className={classes.formButtonContainer}>
            <OutlinedButton id={'allJobs_createJob'} disabled={searchBtnDisabled} variant='contained' onClick={handleCLick}>
              forms.Search
            </OutlinedButton>
          </FormControl>
        </div>
        {/* for displaying the failed images to user */}
        <ViewQualityCheckImagesData FilterData={val} handleSearchDisabled={handleSearchDisabled} />
      </MainRouteSubRoutePage>
    </>

  )
}

export default ViewQualityCheckImages